<template>
  <div class="page1-box">
    <div class="flex just-end">
      <div class="flex">
        <div class="plan-tit">评测计划</div>
        <SelectTerm
          ref="selectTerm"
          v-model="stageList"
          class="plan-input"
          api="/api-evaluation/organize/web/groupIntraAnalysis/semesterPeriodComboVoList"
          @change="termChange"
          @loaded="onStageListLoad"
        />
        <ReportDownBtn :search-params="searchParams" />
      </div>
    </div>
    <div class="content-box-new">
      <div class="flex">
        <div
          class="search-tab"
          :class="{
            'search-tab-in': searchParams.groupBetweenCompareType === 101
          }"
          @click="changeSearch(101)"
        >
          年级趋势
        </div>
        <div
          class="search-tab"
          :class="{
            'search-tab-in': searchParams.groupBetweenCompareType === 103
          }"
          @click="changeSearch(103)"
        >
          班级趋势
        </div>
      </div>
      <div class="search-box">
        <div
          v-if="searchParams.groupBetweenCompareType === 101"
          class="line1"
        />
        <div
          v-if="searchParams.groupBetweenCompareType === 103"
          class="line2"
        />

        <div v-if="classShow && searchParams.groupBetweenCompareType === 103">
          <div v-if="classList.length > 0">
            <div v-for="(v, index) in classList" :key="index" class="row flex">
              <div class="label flex-center">
                <div class="check-all">
                  {{ v.name }}
                </div>
              </div>
              <div class="row-con flex items-c class-check-box">
                <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                  <el-checkbox
                    v-for="(q, qIndex) in v.classrooms"
                    :key="qIndex"
                    :label="q.id"
                    @change="idsCheckChange(index, qIndex, $event, q.id)"
                  >
                    {{ q.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <!-- <div class="label flex-center class">班级</div>
          <div v-if="classList.length > 0" class="row-con">
            <div v-for="(v, index) in classList" :key="index">
              <div class="check-all">
                <el-checkbox
                  v-model="v.checkAll"
                  @change="handleCheckAllClassChange($event, index)"
                >
                  {{ v.name }}
                </el-checkbox>
              </div>
              <div class="flex">
                <el-checkbox-group v-model="v.ids" @change="idsChange(index)">
                  <el-checkbox
                    v-for="(q, qIndex) in v.classrooms"
                    :key="qIndex"
                    class="mb5"
                    :label="q.id"
                  >
                    {{ q.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div> -->
        </div>
        <div>
          <div
            v-if="searchParams.groupBetweenCompareType === 101"
            class="row flex no-border"
          >
            <div class="label flex-center">
              <!-- <el-checkbox
                v-model="checkAllAge"
                @change="handleCheckAllAgeChange"
              >
                全选
              </el-checkbox> -->
              年级
            </div>
            <div class="row-con flex items-c">
              <el-checkbox-group
                v-model="searchParams.compareIds"
                @change="handleAgeCheckedChange"
              >
                <el-checkbox
                  v-for="item in $enums.classroomTypes"
                  :key="item.code"
                  :label="item.code"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="row flex">
            <div class="label flex-center">性别</div>
            <div class="row-con flex items-c">
              <el-checkbox-group v-model="searchParams.sexes" :min="1">
                <el-checkbox
                  v-for="item in $enums.gender"
                  :key="item.code"
                  :label="item.code"
                >
                  {{ item.description }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div class="mt20">
        <el-button
          :disabled="
            searchParams.classroomIds.length < 1 &&
              searchParams.groupBetweenCompareType === 103
          "
          type="primary"
          size="small"
          @click="search"
        >
          查询
        </el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>

      <div class="mt20">
        <template v-if="info.heightDistribute || info.synthEZAvgScore">
          <div v-if="resultType !== 103" class="chart-content clearfix">
            <div
              v-if="info.heightDistribute || info.bmidistribute"
              class="panel-wrap fl mb20 mr20"
            >
              <MainTitle title="体格发育" />
              <div class="clearfix mt10">
                <BasePanel
                  v-if="info.heightDistribute"
                  class="item fl mr20 mb10"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.heightDistribute.title"
                  padding="20px"
                  :link="_getChildLink('height')"
                >
                  <BarDashedLine
                    :data-list="info.heightDistribute.details"
                    :color-list="[
                      '#F87A52',
                      '#FFA100',
                      '#6DD400',
                      '#3A91FF',
                      '#A35DFF'
                    ]"
                  />
                </BasePanel>
                <BasePanel
                  v-if="info.bmidistribute"
                  class="item fl"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.bmidistribute.title"
                  padding="20px"
                  :link="_getChildLink('bmi')"
                >
                  <BarDashedLine
                    :data-list="info.bmidistribute.details"
                    :color-list="['#3A91FF', '#6DD400', '#FFB900', '#A35DFF']"
                  />
                </BasePanel>
              </div>
            </div>
            <div v-if="info.synthEZAvgScore" class="panel-wrap fl mb20">
              <MainTitle title="体能发育" />
              <div class="clearfix mt10">
                <BasePanel
                  class="item fl mr20 mb10"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.synthEZAvgScore.title"
                  padding="20px"
                  :link="_getChildLink('avg')"
                >
                  <BarDashed
                    :data-list="info.synthEZAvgScore.details"
                    color="#FB834D"
                  />
                </BasePanel>
                <BasePanel
                  class="item fl"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.synthEZDistribute.title"
                  padding="20px"
                  :link="_getChildLink('distribution')"
                >
                  <BarDashedLine
                    :data-list="info.synthEZDistribute.details"
                    :color-list="[
                      '#F87A52',
                      '#FFA100',
                      '#6DD400',
                      '#3A91FF',
                      '#A35DFF'
                    ]"
                  />
                </BasePanel>
              </div>
            </div>
          </div>
          <div v-if="resultType === 103" class="chart-content clearfix">
            <div
              v-if="info.heightDistribute || info.bmidistribute"
              class="panel-wrap panel-wrap-class fl mb20 mr20"
            >
              <MainTitle title="体格发育" />
              <div class="clearfix mt10">
                <BasePanel
                  v-if="info.heightDistribute"
                  class="item item-class fl mr20 mb10"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.heightDistribute.title"
                  padding="20px"
                  :link="_getChildLink('height')"
                >
                  <BarDashedLine
                    :data-list="info.heightDistribute.details"
                    :color-list="[
                      '#F87A52',
                      '#FFA100',
                      '#6DD400',
                      '#3A91FF',
                      '#A35DFF'
                    ]"
                  />
                </BasePanel>
                <BasePanel
                  v-if="info.bmidistribute"
                  class="item item-class fl"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.bmidistribute.title"
                  padding="20px"
                  :link="_getChildLink('bmi')"
                >
                  <BarDashedLine
                    :data-list="info.bmidistribute.details"
                    :color-list="['#3A91FF', '#6DD400', '#FFB900', '#A35DFF']"
                  />
                </BasePanel>
              </div>
            </div>
            <div
              v-if="info.synthEZAvgScore"
              class="panel-wrap panel-wrap-class fl mb20"
            >
              <MainTitle title="体能发育" />
              <div class="clearfix mt10">
                <BasePanel
                  class="item item-class fl mr20 mb10"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.synthEZAvgScore.title"
                  padding="20px"
                  :link="_getChildLink('avg')"
                >
                  <BarNorm :data-list="info.synthEZAvgScore.details" />
                </BasePanel>
                <BasePanel
                  class="item item-class fl"
                  :style="{width: dataLength > 3 ? '100%' : '445px'}"
                  :title="info.synthEZDistribute.title"
                  padding="20px"
                  :link="_getChildLink('distribution')"
                >
                  <BarDashedLine
                    :data-list="info.synthEZDistribute.details"
                    :color-list="[
                      '#F87A52',
                      '#FFA100',
                      '#6DD400',
                      '#3A91FF',
                      '#A35DFF'
                    ]"
                  />
                </BasePanel>
              </div>
            </div>
          </div>
        </template>
        <no-data v-else />
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupTrendGroupBetweenCompare,
  getClassList,
  groupCompareGroupList
} from '@/api/teachingProtection/assessment'
import SelectTerm from '@/components/SelectTerm/index.vue'

import BarDashed from '../_components/charts/BarDashed.vue'
import BarNorm from '../_components/charts/BarNorm.vue'
import BarDashedLine from '../_components/charts/BarDashedLine.vue'
import MainTitle from '../_components/MainTitle.vue'
import BasePanel from '@/components/BasePanel/index.vue'

import ReportDownBtn from './_components/ReportDownBtn.vue'

export default {
  components: {
    BarDashed,
    MainTitle,
    BasePanel,
    SelectTerm,
    BarNorm,
    BarDashedLine,
    ReportDownBtn
  },
  props: {
    tabPosition: {}
  },

  data() {
    return {
      searchParams: {
        sexes: [101, 102],
        classroomIds: [],
        compareIds: [101],
        year: '',
        semesterType: '',
        periodType: '',
        groupBetweenCompareType: 101
      },
      ageList: [
        {
          label: '3-4岁',
          value: 101
        },
        {
          label: '4-5岁',
          value: 102
        },
        {
          label: '5-6岁',
          value: 103
        },
        {
          label: '6-7岁',
          value: 104
        }
      ],
      classList: [],
      checkAllAge: true,
      classShow: true,
      info: {
        heightDistribute: { title: '身高分布', details: [] },
        bmidistribute: { title: 'BMI分布', details: [] },
        synthEZAvgScore: { title: '综合能力均分', details: [] },
        synthEZDistribute: { title: '综合能力分布', details: [] }
      },
      stageList: [],
      dataLength: 0,
      resultType: 0,
      groupList: [],
      serachTab: 1,
      nowPrams: {},
      pdfShow: false
    }
  },
  created() {},
  mounted() {
    this.searchParams.tabPosition = this.tabPosition
  },
  methods: {
    termChange(v) {
      this.searchParams.year = v[0]
      this.searchParams.semesterType = v[1]
      this.searchParams.periodType = v[2]
      this.onStageListLoad(true)
    },
    downPdf() {
      this.loading = true
      const ele1 = document.getElementById('page3Pdf1')
      const ele2 = document.getElementById('page3Pdf2')
      const ele3 = document.getElementById('page3Pdf3')
      savePdfImgs([ele1, ele2, ele3], '群体趋势报告', () => {
        this.loading = false
      })
    },
    changeSearch(tab) {
      this.searchParams.groupBetweenCompareType = tab
      this.reset()
    },
    getGroupList() {
      groupCompareGroupList({}).then((res) => {
        this.groupList = res.data.array || []
      })
    },
    onStageListLoad(noTermChange) {
      this.getGroupList()
      getClassList({
        year: this.searchParams.year,
        semesterType: this.searchParams.semesterType,
        periodType: this.searchParams.periodType
      }).then((res) => {
        let params = ''
        if (localStorage.getItem('searchParams')) {
          params = JSON.parse(localStorage.getItem('searchParams'))
        }
        console.info(params)
        if (params) {
          if (params.compareIds) {
            this.searchParams.compareIds = params.compareIds
            this.handleAgeCheckedChange(this.searchParams.compareIds)
          }
          if (!noTermChange) {
            this.searchParams.year = params.year
            this.searchParams.semesterType = params.semesterType
            this.searchParams.periodType = params.periodType
            console.info(this.searchParams)
            this.stageList = [
              params.year,
              params.semesterType,
              params.periodType
            ]
          }
          if (params.tabPosition === 3) {
            this.searchParams.groupBetweenCompareType =
              params.groupBetweenCompareType
          }
        }
        console.info(params)
        this.classList = res.data.array.filter((v) => {
          return v.name !== '其他'
        })
        this.classList.map((v, index) => {
          v.ids = []
          if (params && params.tabPosition === 3) {
            v.classrooms.map((q) => {
              if (params.classroomIds.indexOf(q.id) !== -1) {
                v.ids.push(q.id)
              }
            })
          }
          console.info(v.ids)
          let checkedCount = this.classList[index].ids.length
          this.classList[index].checkAll =
            checkedCount === this.classList[index].classrooms.length
        })
        // if (params.classroomIds) {
        //   this.searchParams = params.classroomIds
        // }
        this.search()
      })
    },
    getInfo() {
      groupTrendGroupBetweenCompare(this.searchParams).then((res) => {
        this.$fn.setVal(this.info, res.data)
        if (res.data.heightDistribute) {
          this.dataLength = res.data.heightDistribute.details.length
        }
        // this.resultType = this.searchParams.groupBetweenCompareType
      })
    },
    _getChildLink(type) {
      if (this.searchParams.groupBetweenCompareType === 101) {
        return `/trendStatistics/${type}?searchParams=${encodeURIComponent(
          JSON.stringify(this.nowPrams)
        )}`
      } else {
        return `/trendStatistics/${type}?searchParams=${encodeURIComponent(
          JSON.stringify(this.nowPrams)
        )}`
      }
    },
    onDetailClick() {
      this.$emit('button-click')
    },
    handleCheckAllAgeChange(val) {
      const arr = []
      this.$enums.classroomTypes.map((v) => {
        arr.push(v.code)
      })
      if (val) {
        this.searchParams.compareIds = arr
      } else {
        this.searchParams.compareIds = []
      }
    },
    handleAgeCheckedChange(val) {
      // console.info(val);
      this.searchParams.compareIds = [val[val.length - 1]]
      // let checkedCount = val.length;
      // this.checkAllAge = checkedCount === this.$enums.classroomTypes.length;
    },
    idsCheckChange(index, qIndex, val, id) {
      console.info(index, qIndex, val)

      this.classList.map((v) => {
        v.ids = []
      })
      if (val) {
        this.classList[index].ids = [id]
        this.searchParams.classroomIds = [id]
      } else {
        this.searchParams.classroomIds = []
      }
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
      })
      // console.info(this.classList)
    },
    idsChange(index) {
      // this.classShow = false
      // this.$nextTick(() => {
      //   this.classShow = true
      //   let checkedCount = this.classList[index].ids.length
      //   this.classList[index].checkAll =
      //     checkedCount === this.classList[index].classrooms.length
      // })
      // const arr1 = []
      // this.classList.map((v) => {
      //   v.ids.map((q) => {
      //     arr1.push(q)
      //   })
      // })
      // this.searchParams.classroomIds = arr1
    },
    handleCheckAllClassChange(val, index) {
      const arr = []
      this.classList[index].classrooms.map((v) => {
        arr.push(v.id)
      })
      if (val) {
        this.classList[index].ids = arr
      } else {
        this.classList[index].ids = []
      }
      this.classShow = false
      this.$nextTick(() => {
        this.classShow = true
      })
      const arr1 = []
      this.classList.map((v) => {
        v.ids.map((q) => {
          arr1.push(q)
        })
      })
      this.searchParams.classroomIds = arr1
    },
    search() {
      const arr = []
      this.classList.map((v) => {
        v.ids.map((q) => {
          arr.push(q)
        })
      })
      this.searchParams.classroomIds = arr
      this.searchParams.year = this.stageList[0] || ''
      this.searchParams.semesterType = this.stageList[1] || ''
      this.searchParams.periodType = this.stageList[2] || ''
      this.nowPrams = this.$fn.deepClone(this.searchParams)
      this.getInfo()
      this.pdfShow = false
      this.$nextTick(() => {
        this.pdfShow = true
      })
    },
    reset() {
      this.searchParams.classroomIds = []
      this.searchParams.sexes = [101, 102]
      console.info(this.tabPosition)
      if (this.searchParams.groupBetweenCompareType === 101) {
        this.searchParams.compareIds = [101]
      } else {
        this.searchParams.compareIds = []
      }
      this.checkAllAge = true
      // this.$refs.selectTerm.reset();
      this.classList.map((v) => {
        v.checkAll = false
        v.ids = []
      })
      this.$nextTick(() => {
        this.searchParams.year = this.stageList[0] || ''
        this.searchParams.semesterType = this.stageList[1] || ''
        this.searchParams.periodType = this.stageList[2] || ''

        this.nowPrams = this.$fn.deepClone(this.searchParams)
        this.getInfo()
        this.pdfShow = false
        this.$nextTick(() => {
          this.pdfShow = true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.down-btn {
  height: 32px;
  line-height: 10px;
}
.search-tab {
  width: 88px;
  height: 36px;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.search-tab-in {
  border: 2px solid #ff7146;
}

.page1-box {
  margin-top: -30px;
}
.plan-tit {
  width: 100px;
  line-height: 30px;
  font-size: 14px;
}
.plan-input {
  width: 400px;
}
.search-box {
  border: 2px solid #ff7146;
  position: relative;
  .line1 {
    position: absolute;
    height: 4px;
    width: 84px;
    background: #ffffff;
    left: 0;
    top: -4px;
  }
  .line2 {
    position: absolute;
    height: 4px;
    width: 84px;
    background: #ffffff;
    left: 88px;
    top: -4px;
  }
  .row {
    border-bottom: 1px solid #e8edf2;
    .label {
      // background: #f5f7fa;
      width: 88px;
      min-height: 56px;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        background: #d8d8d8;
        width: 1px;
        height: 18px;
        top: 50%;
        transform: translate(0, -50%);
        right: 0;
      }
    }
    .class {
      min-height: 85px !important;
    }
    .row-con {
      padding: 10px 20px;
      width: 100%;
    }
    .check-all {
      margin: 5px 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.panel-wrap {
  padding: 20px 30px;
  background: #f6f6f6;
  border-radius: 10px;
}
.item {
  width: 360px;
  height: 380px;
  position: relative;
}
.panel-content {
  padding: 20px;
}
.score {
  .number {
    color: #fb834d;
    font-size: 40px;
  }
}
.c-score {
  color: #fb834d;
}
</style>
